/* Wine Majesty — Cart Page JS */

(function () {
  'use strict';

  /* ZIP of the last successful shipping quote, so the quote can be refreshed
     when the cart changes instead of going stale. */
  var lastQuotedZip = '';

  const SAVED_KEY = 'wm_saved_for_later';
  const RECENT_KEY = 'wm_recently_viewed';
  const SHOP_CURRENCY = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';

  /* ─── Utility ─────────────────────────────────────────────── */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeCartItem(id, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST' }).then(function (r) { return r.json(); });
  }

  /* Re-fetch and swap the data-html="list" section so Empire's state stays in sync */
  function refreshCartSection() {
    return fetch('/?sections=static-cart')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['static-cart'];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* If cart is now empty, reload — sidebar would otherwise stay with stale data */
        if (doc.querySelector('.wm-cart-empty')) {
          window.location.reload();
          return;
        }

        /* Swap items list. The list column also holds the incomplete-system
           warning, "Complete your setup" and "Saved for later", so those are
           re-rendered here too. */
        var newList = doc.querySelector('[data-html="list"]');
        var curList = document.querySelector('[data-html="list"]');
        if (newList && curList) curList.innerHTML = newList.innerHTML;
        syncMinusButtons();
        renderSavedForLater();
        loadUpsell();

        /* Swap cart total */
        var newTotal = doc.querySelector('[data-html="cart_total"]');
        var curTotal = document.querySelector('[data-html="cart_total"]');
        if (newTotal && curTotal) curTotal.textContent = newTotal.textContent;

        /* Shop Pay installments banner: swap in the one the server just rendered
           for the new total. Shopify's banner is meant to follow data-cart-subtotal
           on its own, but in testing it kept the old monthly amount after a
           quantity change; a fresh element always renders the right offer. */
        var newTerms = doc.querySelector('.wm-cs-financing shopify-payment-terms');
        var curTerms = document.querySelector('.wm-cs-financing shopify-payment-terms');
        if (newTerms && curTerms &&
            newTerms.getAttribute('shopify-meta') !== curTerms.getAttribute('shopify-meta')) {
          curTerms.replaceWith(document.importNode(newTerms, true));
        }

        /* Swap free shipping bar */
        var newFSB = doc.querySelector('[data-html="free_shipping_bar"]');
        var curFSB = document.querySelector('[data-html="free_shipping_bar"]');
        if (newFSB && curFSB) curFSB.innerHTML = newFSB.innerHTML;

        /* Update order total in summary */
        fetchCart().then(function (cart) {
          updateSummaryTotals(cart);
          updateHeaderCount(cart.item_count);
        });
      });
  }

  function updateSummaryTotals(cart) {
    var totalEls = document.querySelectorAll('[data-wm-order-total]');
    totalEls.forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    var mobileAmt = document.querySelector('.wm-mb-amount');
    if (mobileAmt) mobileAmt.textContent = formatMoney(cart.total_price);

    /* The cart just changed, so any shipping quote on screen is stale. */
    if (lastQuotedZip) calcShipping(true);
  }

  function updateHeaderCount(count) {
    var badge = document.querySelector('[data-header-cart-count]');
    if (!badge) return;
    badge.setAttribute('data-header-cart-count', count > 0 ? count : '');
    badge.classList.toggle('visible', count > 0);
  }

  /* ─── Remove all ──────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wm-cart-clear]')) return;
    if (!confirm('Remove all items from your cart?')) return;
    clearCart().then(function () {
      window.location.reload();
    });
  });

  /* ─── qty: cart:quantity event from quantity-selector ──────── */
  document.addEventListener('cart:quantity', function (e) {
    var key = e.detail[0];
    var qty = e.detail[1];
    if (!key) return;
    changeCartItem(key, qty).then(function () {
      refreshCartSection();
    });
  });

  /* Enable or disable each cart line's minus button from its current quantity.
     The server renders every minus button disabled, and after refreshCartSection()
     swaps the list nothing else re-enables it, so this runs after every swap. */
  function syncMinusButtons() {
    document.querySelectorAll('[data-cartitem-key] [data-quantity-selector]').forEach(function (qsEl) {
      var input = qsEl.querySelector('[data-quantity-input]');
      var wrap = qsEl.querySelector('[data-button-wrapper-minus]');
      if (!input || !wrap) return;
      var step = parseInt(input.getAttribute('data-increment-value'), 10) || 1;
      var qty = parseInt(input.value, 10) || 0;
      wrap.classList.toggle('quantity-selector__button-wrapper--disabled', qty <= step);
    });
  }

  /* ─── qty: cart line +/− buttons, capture phase ──────────────────
     Empire's StaticCart also binds a click handler to every + and − button and
     updates the cart on its own. With both running, one click moved the quantity
     by two (1 to 3, or 2 straight to removal). This handler owns cart-line clicks:
     it runs in the capture phase and stops the event, so Empire's copy never fires.
     Product page buttons (name="quantity") are left to the handler further down. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!btn) return;

    /* If Empire's CE is defined and this element is a proper instance, skip —
       the CE will fire cart:quantity and the listener above handles it */
    var CeClass = window.customElements && customElements.get('quantity-selector');
    if (CeClass) {
      var qs = btn.closest('quantity-selector');
      if (qs && qs instanceof CeClass) return;
    }

    var qsEl = btn.closest('[data-quantity-selector]');
    if (!qsEl) return;
    var input = qsEl.querySelector('[data-quantity-input]');
    if (!input) return;
    if (!input.name || input.name.indexOf('updates') !== 0) return;
    var li = btn.closest('[data-cartitem-key]');
    if (!li) return;

    e.preventDefault();
    e.stopPropagation();

    var key = li.getAttribute('data-cartitem-key');
    var step = parseInt(input.getAttribute('data-increment-value'), 10) || 1;
    var qty = parseInt(input.value, 10) || 1;

    if (btn.hasAttribute('data-quantity-plus')) {
      qty += step;
    } else {
      qty = Math.max(0, qty - step);
    }

    input.value = qty;

    var minusWrapper = qsEl.querySelector('[data-button-wrapper-minus]');
    if (minusWrapper) {
      minusWrapper.classList.toggle('quantity-selector__button-wrapper--disabled', qty <= step);
    }

    li.style.opacity = '0.6';
    li.style.pointerEvents = 'none';

    changeCartItem(key, qty).then(function () {
      refreshCartSection().then(function () {
        li.style.opacity = '';
        li.style.pointerEvents = '';
      });
    }).catch(function () {
      li.style.opacity = '';
      li.style.pointerEvents = '';
    });
  }, true); /* capture phase, so it runs before Empire's handler on the button */

  /* ─── qty: product page — capture phase (fires before Empire CE bubble handlers) ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!btn) return;

    var qsEl = btn.closest('[data-quantity-selector]');
    if (!qsEl) return;
    var input = qsEl.querySelector('[data-quantity-input]');
    if (!input) return;

    /* Only product-context (name="quantity") — cart context handled in bubble phase above */
    if (!input.name || input.name !== 'quantity') return;

    var step = parseInt(input.getAttribute('data-increment-value'), 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var qty = parseInt(input.value, 10) || min;

    if (btn.hasAttribute('data-quantity-plus')) {
      qty += step;
    } else {
      qty = Math.max(min, qty - step);
    }

    input.value = qty;

    var minusWrapper = qsEl.querySelector('[data-button-wrapper-minus]');
    if (minusWrapper) {
      minusWrapper.classList.toggle('quantity-selector__button-wrapper--disabled', qty <= min);
    }

    /* stopPropagation prevents CE bubble handler from also running and double-incrementing */
    e.stopPropagation();
  }, true); /* capture phase */

  /* ─── qty: handle direct input edit (user types a number) ─── */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.hasAttribute('data-quantity-input')) return;
    if (!input.name || !input.name.startsWith('updates')) return;

    var li = input.closest('[data-cartitem-key]');
    if (!li) return;

    var key = li.getAttribute('data-cartitem-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;

    li.style.opacity = '0.6';
    li.style.pointerEvents = 'none';

    changeCartItem(key, qty).then(function () {
      refreshCartSection().then(function () {
        li.style.opacity = '';
        li.style.pointerEvents = '';
      });
    }).catch(function () {
      li.style.opacity = '';
      li.style.pointerEvents = '';
    });
  });

  /* ─── Remove item (data-cartitem-remove) ───────────────────── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cartitem-remove]');
    if (!link) return;
    e.preventDefault();
    var li = link.closest('[data-cartitem]');
    var key = li ? li.getAttribute('data-cartitem-key') : null;
    if (!key) return;
    li.style.opacity = '0.4';
    li.style.pointerEvents = 'none';
    changeCartItem(key, 0).then(function () {
      refreshCartSection().then(function () {
        renderSavedForLater();
      });
    });
  });

  /* ─── Promo code toggle ─────────────────────────────────────── */
  var promoToggle = document.getElementById('wmPromoToggle');
  var promoInput = document.getElementById('wmPromoInput');
  var promoMsg = document.getElementById('wmPromoMsg');
  var promoApply = document.getElementById('wmPromoApply');
  var promoCode = document.getElementById('wm-promo-code');

  if (promoToggle && promoInput) {
    promoToggle.addEventListener('click', function () {
      var expanded = promoToggle.getAttribute('aria-expanded') === 'true';
      promoToggle.setAttribute('aria-expanded', !expanded);
      promoInput.hidden = expanded;
      if (!expanded && promoCode) promoCode.focus();
    });
  }

  if (promoApply && promoCode) {
    promoApply.addEventListener('click', applyPromo);
    promoCode.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyPromo();
    });
  }

  function applyPromo() {
    var code = promoCode ? promoCode.value.trim() : '';
    if (!code) return;
    /* Shopify discount codes apply at checkout via cookie */
    window.location.href = '/discount/' + encodeURIComponent(code) + '?return_to=/cart';
  }

  /* ─── ZIP / shipping calc ───────────────────────────────────── */
  var zipInput = document.getElementById('wm-zip');
  var zipBtn = document.getElementById('wmZipCheck');
  var zipResult = document.getElementById('wmZipResult');
  var zipBtnLabel = zipBtn ? zipBtn.textContent.trim() : 'Update';

  if (zipBtn && zipInput) {
    zipBtn.addEventListener('click', function () { calcShipping(false); });
    zipInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); calcShipping(false); }
    });
  }

  /* USPS 3 digit ZIP prefix ranges mapped to their state code.
     Shopify's /cart/shipping_rates.json REQUIRES a province and it validates
     the ZIP against that province, so a bad lookup can only ever surface as
     "not a valid ZIP", never as a wrong price. */
  var ZIP_PREFIX_STATES = [
    [5, 5, 'NY'], [6, 9, 'PR'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'],
    [39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'], [90, 98, 'AE'],
    [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'], [200, 200, 'DC'],
    [201, 201, 'VA'], [202, 205, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'],
    [247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'],
    [320, 339, 'FL'], [340, 340, 'AA'], [341, 349, 'FL'], [350, 369, 'AL'],
    [370, 385, 'TN'], [386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'],
    [430, 459, 'OH'], [460, 479, 'IN'], [480, 499, 'MI'], [500, 528, 'IA'],
    [530, 549, 'WI'], [550, 567, 'MN'], [569, 569, 'DC'], [570, 577, 'SD'],
    [580, 588, 'ND'], [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'],
    [660, 679, 'KS'], [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'],
    [730, 732, 'OK'], [733, 733, 'TX'], [734, 749, 'OK'], [750, 799, 'TX'],
    [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'], [840, 847, 'UT'],
    [850, 865, 'AZ'], [870, 884, 'NM'], [885, 885, 'TX'], [889, 898, 'NV'],
    [900, 961, 'CA'], [962, 966, 'AP'], [967, 968, 'HI'], [969, 969, 'GU'],
    [970, 979, 'OR'], [980, 994, 'WA'], [995, 999, 'AK']
  ];

  function stateFromZip(zip5) {
    var p = parseInt(zip5.slice(0, 3), 10);
    if (isNaN(p)) return '';
    for (var i = 0; i < ZIP_PREFIX_STATES.length; i++) {
      if (p >= ZIP_PREFIX_STATES[i][0] && p <= ZIP_PREFIX_STATES[i][1]) {
        return ZIP_PREFIX_STATES[i][2];
      }
    }
    return '';
  }

  function setShippingSummary(text) {
    var el = document.getElementById('wmCsShipping');
    if (el) el.textContent = text;
  }

  function showZipMessage(msg) {
    if (!zipResult) return;
    zipResult.textContent = msg;
    zipResult.hidden = false;
  }

  function priceLabel(value) {
    return '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* silent = re-run an existing quote after the cart changed, without
     flashing the button or clearing the message the shopper is reading */
  function calcShipping(silent) {
    if (!zipInput || !zipBtn || !zipResult) return;

    var digits = zipInput.value.replace(/[^0-9]/g, '').slice(0, 5);

    if (digits.length !== 5) {
      lastQuotedZip = '';
      setShippingSummary('Calculated at checkout');
      if (!silent) showZipMessage('Enter a 5 digit US ZIP code.');
      return;
    }

    var state = stateFromZip(digits);
    if (!state) {
      lastQuotedZip = '';
      setShippingSummary('Calculated at checkout');
      if (!silent) showZipMessage('We could not match that ZIP code. Your rate is shown at checkout.');
      return;
    }

    if (!silent) {
      zipBtn.disabled = true;
      zipBtn.textContent = 'Checking';
      zipResult.hidden = true;
    }

    function reset() {
      zipBtn.disabled = false;
      zipBtn.textContent = zipBtnLabel;
    }

    function fail(msg) {
      reset();
      lastQuotedZip = '';
      setShippingSummary('Calculated at checkout');
      showZipMessage(msg);
    }

    fetch('/cart/shipping_rates.json'
      + '?shipping_address[country]=US'
      + '&shipping_address[province]=' + encodeURIComponent(state)
      + '&shipping_address[zip]=' + encodeURIComponent(digits))
      .then(function (r) {
        return r.text().then(function (body) {
          var parsed = null;
          try { parsed = JSON.parse(body); } catch (e) {}
          return { ok: r.ok, data: parsed };
        });
      })
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.shipping_rates) {
          if (res.data && res.data.zip) {
            fail('That ZIP code is not valid for ' + state + '. Please check it.');
          } else {
            fail('We could not calculate that right now. Your rate is shown at checkout.');
          }
          return;
        }

        var rates = res.data.shipping_rates;
        if (!rates.length) {
          fail('No delivery options for ' + state + ' ' + digits + '. Call (331) 244-8273 and we will sort it out.');
          return;
        }

        reset();
        lastQuotedZip = digits;

        var sorted = rates.slice().sort(function (a, b) {
          return parseFloat(a.price) - parseFloat(b.price);
        });
        var pick = sorted[0];
        var price = parseFloat(pick.price);

        if (price === 0) {
          setShippingSummary('FREE');
          showZipMessage('Free shipping to ' + state + ' ' + digits + '.');
        } else {
          setShippingSummary(priceLabel(price));
          showZipMessage((sorted.length > 1 ? 'From ' : '') + priceLabel(price)
            + ' to ' + state + ' ' + digits + ' (' + pick.name + '). Added at checkout.');
        }
      })
      .catch(function () {
        fail('We could not calculate that right now. Your rate is shown at checkout.');
      });
  }

  /* ─── Saved for later ────────────────────────────────────────── */
  function getSaved() {
    try { return JSON.parse(localStorage.getItem(SAVED_KEY)) || []; }
    catch (e) { return []; }
  }

  function setSaved(items) {
    localStorage.setItem(SAVED_KEY, JSON.stringify(items));
  }

  /* Save item button */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wm-save-later]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-wm-save-later');
    var item = {
      key: key,
      variantId: btn.getAttribute('data-variant-id'),
      productId: btn.getAttribute('data-product-id'),
      title: btn.getAttribute('data-title'),
      vendor: btn.getAttribute('data-vendor'),
      price: parseInt(btn.getAttribute('data-price'), 10),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url')
    };
    var saved = getSaved();
    if (!saved.find(function (s) { return s.key === key; })) {
      saved.push(item);
      setSaved(saved);
    }
    changeCartItem(key, 0).then(function () {
      refreshCartSection().then(function () {
        renderSavedForLater();
      });
    });
  });

  /* Move back to cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wm-move-to-cart]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-wm-move-to-cart');
    var key = btn.getAttribute('data-saved-key');
    btn.textContent = 'Adding…';
    btn.disabled = true;
    addToCart(variantId, 1).then(function () {
      var saved = getSaved().filter(function (s) { return s.key !== key; });
      setSaved(saved);
      refreshCartSection().then(function () {
        renderSavedForLater();
      });
    }).catch(function () {
      btn.textContent = 'Move to cart';
      btn.disabled = false;
    });
  });

  function renderSavedForLater() {
    var block = document.getElementById('wm-saved-block');
    var container = document.getElementById('wm-saved-items');
    var countEl = document.getElementById('wm-saved-count');
    if (!block || !container) return;

    var saved = getSaved();
    if (saved.length === 0) {
      block.hidden = true;
      return;
    }

    block.hidden = false;
    if (countEl) countEl.textContent = '(' + saved.length + (saved.length === 1 ? ' item' : ' items') + ')';

    container.innerHTML = saved.map(function (item) {
      return '<div class="wm-sr-item">' +
        '<div class="wm-sr-img">' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="70" height="70">' : '') +
        '</div>' +
        '<div class="wm-sr-meta">' +
          '<div class="wm-sr-brand">' + escapeHtml(item.vendor) + '</div>' +
          '<div class="wm-sr-title">' + escapeHtml(item.title) + '</div>' +
          '<div class="wm-sr-price">' + formatMoney(item.price) + '</div>' +
        '</div>' +
        '<button class="wm-sr-btn" type="button" data-wm-move-to-cart="' + item.variantId + '" data-saved-key="' + escapeHtml(item.key) + '">Move to cart</button>' +
      '</div>';
    }).join('');
  }

  /* ─── Complete your setup ─────────────────────────────────────
     snippets/wm-cart-addons.liquid renders Wine Guardian add-ons on the server.
     When it has none, it leaves the block hidden with data-wm-comp-pids (product
     ids from the cart), and this asks Shopify for complementary products: the
     pairs set in the Search & Discovery app. No pairs, no block.
     (The old version sent a variant id to the recommendations endpoint, which
     always answered 404, so the block never showed.) */
  var complementaryCache = {};

  function plainMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fetchComplementary(productId) {
    if (!complementaryCache[productId]) {
      complementaryCache[productId] = fetch('/recommendations/products.json?product_id=' +
          encodeURIComponent(productId) + '&intent=complementary&limit=4')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) { return (data && data.products) || []; })
        .catch(function () { return []; });
    }
    return complementaryCache[productId];
  }

  function complementaryRow(p, v) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    var url = '/products/' + p.handle;
    var variantLabel = (p.variants.length > 1 && v.title && v.title !== 'Default Title')
      ? '<span class="wm-upr-var">' + escapeHtml(v.title) + '</span>' : '';
    return '<div class="wm-upr">' +
      '<a class="wm-upr-img" href="' + url + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + escapeHtml(img) + (img.indexOf('?') === -1 ? '?' : '&') + 'width=160" alt="" loading="lazy" width="64" height="64">' : '') +
      '</a>' +
      '<div class="wm-upr-info">' +
        '<span class="wm-upr-brand">' + escapeHtml(p.vendor) + '</span>' +
        '<a class="wm-upr-title" href="' + url + '">' + escapeHtml(p.title) + '</a>' +
        variantLabel +
      '</div>' +
      '<span class="wm-upr-price">' + plainMoney(v.price) + '</span>' +
      '<button class="wm-upr-add" type="button" data-wm-upsell-add="' + v.id + '" aria-label="Add ' + escapeHtml(p.title) + ' to cart">+ Add</button>' +
    '</div>';
  }

  function loadUpsell() {
    var block = document.getElementById('wm-upsell-block');
    if (!block || !block.hasAttribute('data-wm-comp-pids')) return;
    var list = block.querySelector('#wm-upsell-items');
    var ids = (block.getAttribute('data-wm-comp-pids') || '').split(',').filter(Boolean).slice(0, 3);
    if (!list || !ids.length) return;
    var inCart = block.getAttribute('data-wm-cart-pids') || ','; /* ",id1,id2," */

    Promise.all(ids.map(fetchComplementary)).then(function (lists) {
      /* a cart refresh may have replaced the block while this was loading */
      if (!document.body.contains(block)) return;
      var seen = {};
      var rows = [];
      lists.forEach(function (products) {
        products.forEach(function (p) {
          if (rows.length >= 3 || !p || seen[p.id]) return;
          if (inCart.indexOf(',' + p.id + ',') !== -1) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          seen[p.id] = true;
          rows.push(complementaryRow(p, v));
        });
      });
      if (!rows.length) return;
      list.innerHTML = rows.join('');
      block.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wm-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-wm-upsell-add'), 10);
    if (!variantId || btn.disabled) return;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.textContent = 'Added';
      return refreshCartSection();
    }).catch(function () {
      btn.textContent = label;
      btn.disabled = false;
    });
  });

  /* ─── Recently viewed ────────────────────────────────────────── */
  function loadRecentlyViewed() {
    var section = document.getElementById('wm-recent-section');
    var grid = document.getElementById('wm-recent-items');
    if (!section || !grid) return;

    var handles;
    try { handles = JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { handles = []; }

    handles = handles.slice(0, 4);
    if (handles.length === 0) return;

    var promises = handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) return;

      section.hidden = false;
      grid.innerHTML = valid.map(function (p) {
        var img = p.images[0];
        var price = p.variants[0] ? p.variants[0].price : 0;
        return '<a href="/products/' + p.handle + '" class="wm-rec-card">' +
          '<div class="wm-rec-img">' +
            (img ? '<img src="' + img.replace(/(\.[^.]+)$/, '_400x400$1') + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="400">' : '') +
          '</div>' +
          '<div class="wm-rec-brand">' + escapeHtml(p.vendor) + '</div>' +
          '<div class="wm-rec-title">' + escapeHtml(p.title) + '</div>' +
          '<div class="wm-rec-price">' + formatMoney(price) + '</div>' +
        '</a>';
      }).join('');
    });
  }

  function escapeHtml(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ─── Init ───────────────────────────────────────────────────── */
  syncMinusButtons();
  renderSavedForLater();
  loadUpsell();
  loadRecentlyViewed();

})();
